/* eslint-disable react-hooks/exhaustive-deps */
import { VbzCheckbox } from '@smiles/voebiz-ui-kit';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useFilterData from '../../hooks/useFilterData';
import { CheckboxProps } from './types/types';
import { SyntheticEvent } from '../../types/event.type';

const CheckboxAvailable = ({ engagedAvailable, setAvailablePlanValue, setUncheckBoxAvailable }: CheckboxProps) => {
  const { t } = useTranslation('modalFilter');
  const plansAvailable = t('plans', { returnObjects: true }) as Array<string>;
  const { allStatesAvailableCheckEngaged } = useFilterData();
  const [availablePlans, setAvailablePlans] = useState<string[]>([]);

  const handleCheckBoxAvailablePlan = async (e: SyntheticEvent) => {
    if (!availablePlans.includes(e.target.value) && e.target.checked === true) {
      setAvailablePlans([...availablePlans, e.target.value]);
    }
    if (e.target.checked === false) {
      const auxArray = [...availablePlans];
      for (let indice = 0; indice < availablePlans.length; indice += 5) {
        if (availablePlans[indice] + 5 === e.target.id) {
          auxArray.splice(indice, 5);
          setAvailablePlans(auxArray);
          setUncheckBoxAvailable ? setUncheckBoxAvailable(true) : '';
        }
      }
    }
  };
  useEffect(() => {
    if (setAvailablePlanValue) setAvailablePlanValue(availablePlans);
  }, [availablePlans]);

  useEffect(() => {
    Object.entries(allStatesAvailableCheckEngaged).forEach((index: [string, boolean]) => {
      if (index[1] === true) {
        setAvailablePlans((array: string[]) => [...array, index[0]]);
      }
    });
  }, []);

  return (
    <>
      {engagedAvailable && (
        <div className="modalcheckbox">
          <div className="checkboxhabilitado" key={'0'}>
            <VbzCheckbox
              id={'0' + 5}
              label={`Sem planos disponíveis`}
              checked={availablePlans.includes('0')}
              value={'0'}
              onChange={(e) => handleCheckBoxAvailablePlan(e)}
              data-testid="available-checkbox"
              className="available-checkbox-class"
            />
          </div>

          {plansAvailable.map((planAvailable) => {
            return (
              <div className="checkboxhabilitado" key={planAvailable}>
                <VbzCheckbox
                  id={planAvailable + 5}
                  label={`Plano ${new Intl.NumberFormat().format(Number(planAvailable))}`}
                  checked={availablePlans.includes(planAvailable)}
                  value={planAvailable}
                  onChange={(e) => handleCheckBoxAvailablePlan(e)}
                />
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default CheckboxAvailable;
